<template>
  <div class="profil-container">
    <h3 class="profil-title">
      Selamat Datang di Halaman Pengisian dan Unggah Dokumen Prakualifikasi K3L Berau Coal
    </h3>
    <div class="instruction-wrapper">
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Mohon untuk mengisi data selengkap mungkin demi mempermudah untuk
          lolos sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Lengkapi semua bagian pada formulir Pra-Kualifikasi ini serta
          lampirkan dokumen pendukung dan isian tambahan (jika ada).
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Formulir Pra-Kualifikasi K3L ini digunakan sebagai salah satu
          penilaian utama dalam penetapan tingkat risiko pekerjaan Calon Vendor.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">4.</div>
        <div class="instruction-text">
          Sesuai dengan Undang-Undang 11 tahun 2020 tentang Cipta Kerja dan
          peraturan KKPM nomor 3 tahun 2021 tentang sistem perizinan berusaha
          berbasis risiko terintegrasi secara elektronik maka dari itu badan
          usaha wajib memiliki NIB untuk pendaftaran sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">5.</div>
        <div class="instruction-text">
          Jika memerlukan bantuan atau penjelasan tentang persyaratan tertentu,
          silahkan hubungi Dept.SIPM
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goNext()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goNext() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'profile' })
    },
  },
}
</script>
